<template>
<div>
  <div class="hidden" v-if="getContent() && false"></div>
  <div
    class="contentblock board_layout"
    :data-block-id="bdata.paperBlockId"
  >
    <ContentBlockCreatorInfo
      :bdata ="bdata"
      :blockModDate="blockModDate"
      :blockRegDate="blockRegDate"
      :blockModUserName="blockModUserName"
      :blockRegUserName="blockRegUserName">
    </ContentBlockCreatorInfo>
    <div class="eidtbox-ty1 align_top">
      <div
        :class="
        linkAttr() && linkAttr('linkType') === 'board' ? 
        'todo_wrap_view hover_box' : 'url_box hover_box tit-only'"
      >
        <!-- [rowbox] -->
        <div class="hover_inner">
          <!-- [드래그 핸들] -->
          <!-- 보이는 드래그 핸들 -->
          <div class="move"></div>
          <!-- 실제 이벤트 드래그 핸들 -->
          <div class="block_handle" ref="dragHandle"
            :data-block-id="bdata.paperBlockId"
            :transfer-data="bdata.paperBlockId"
            @mousedown="dragBlockState(1)"
            @mouseup="dragBlockState(0)"
            @touchstart="dragBlockState(1)"
            @touchend="dragBlockState(0)">
            &nbsp;
          </div>
          <!-- /[드래그 핸들] -->
          <!-- [링크 타입이 보드인 경우] -->
          <template v-if="linkAttr() && linkAttr('linkType') === 'board'">
            <div class="top">
              <div class="label-fin">
                <!-- <template v-if="state.groupKbn == 'PRO' || state.groupKbn == 'USER'">보드</template> -->
                <template v-if="state.groupKbn == 'SHAR'">{{$i18nUtil.trans("entity.paper.groupKbn.shar.002","정보보드")}}</template>
                <template v-else-if="state.groupKbn == 'CFRC'">{{$i18nUtil.trans("entity.paper.groupKbn.cfrc.002","회의보드")}}</template>
                <template v-else>{{$i18nUtil.trans("entity.paper","보드")}}</template>
              </div>
              <span class="team">{{state.subName}}</span>
              <div class="right">
                <div class="re-de">
                  <div class="de">
                    <div class="droplayer relative">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="permit_everyone" v-bind="attrs" v-on="on">
                            <div class="member">
                              <img 
                                class="user-photo"
                                :data-user-id="bdata.regUserId"
                                src="@/assets/img/no-avatar.png"
                                alt=""/>
                              {{ $i18nUtil.getLanguage() !== 'ko' && bdata.regUserNameEn != null ? bdata.regUserNameEn : bdata.regUserName }}
                            </div>
                          </v-btn>
                        </template>
                        <div class="dropdown-list">
                          <UserTooltip :userId="bdata.regUserId"/>
                        </div>
                      </v-menu>
                    </div>
                  </div>
                </div>
                <div class="droplayer icon more large right nosel">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="permit_everyone" v-bind="attrs" v-on="on">{{$i18nUtil.trans("button.more","더보기")}}</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button type="button"
                            @click="deleteFileBlock"
                            >
                            {{$i18nUtil.trans("button.link.delete","링크 삭제")}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>
              </div>
            </div>
            <div class="view"> 
              <a :href="linkAttr('url')">
              {{state.title}} 
              </a>
            </div>
          </template>
          <!-- /[링크 타입이 보드인 경우] -->
          <!-- [링크 타입이 일반 URL 인 경우] -->
          <template v-else>
            <!-- [링크타입 블럭] -->
            <div
              class="img"
              v-if="linkAttr() && testHanwha(linkAttr('url'))">
              <img src="@/assets/img/board_url01.png" alt="" />
            </div>
            <div
              class="img"
              v-else-if="linkAttr() && linkAttr('image')">
              <template v-if="paperInfo.useExternalSite || paperInfo.accessType != 'IN'">
                <img :src="state.linkMeta[0].image" alt="" />
              </template>
              <template v-else>
                <img src="@/assets/img/board_url02.png" alt="" />
              </template>
            </div>
            <div
              class="img"
              v-else>
              <img src="@/assets/img/board_url02.png" alt="" />
            </div>
            <!-- <a class="meta_url" :href="getContent()">{{ getContent() }}</a> -->
            <div class="tit content"
              v-if="linkAttr() && linkAttr('title')"
              :class="state.linkMeta[0] && state.linkMeta[0].description ? 'has_desc' : ''"
              @click="linkClicked">
              &nbsp;
              <span v-if="state.linkMeta[0].linkType === 'file'"></span>
              <span v-if="state.linkMeta[0].linkType === 'google'">[{{$i18nUtil.trans("message.BoardEditor.004","구글드라이브")}}]</span>
              {{ linkAttr("title") }}
            </div>
            <div class="tit content"
              v-else-if="linkAttr()"
              @click="linkClicked">
              &nbsp;
              {{ linkAttr("url") }}
            </div>
            <div class="meta_description"
              v-if="state.linkMeta[0] && state.linkMeta[0].description">
              {{ state.linkMeta[0].description }}
            </div>
            <div class="droplayer relative icon more large right nosel">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="permit_everyone" v-bind="attrs" v-on="on">{{$i18nUtil.trans("button.more","더보기")}}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        class="permit_everyone" 
                        @click="copyURL"
                        type="button">
                        {{$i18nUtil.trans("button.url.copy","URL 복사")}}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button 
                        @click="requestURLContent(getContent(), self)"
                        type="button">
                        {{$i18nUtil.trans("button.url.modify","URL 수정")}}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        @click="deleteFileBlock"
                        type="button">
                        {{$i18nUtil.trans("button.url.delete","URL 삭제")}}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
            <!-- /[링크타입 블럭] -->
          </template>
          <!-- /[링크 타입이 일반 URL 인 경우] -->
          <!-- [의견 영역] -->
          <div
            ref="buttonComment"
            class="hover_comment"
            :class="
            (commentCount ? ' display-block' : '') +
            (blockInfo.commentSelectId === bdata.paperBlockId ? ' display-block active' : '')
            "
            >
            <button type="button" class="permit_everyone" @click="viewComment">
              {{ !commentCount ? "" : commentCount }}
            </button>
          </div>
          <!-- /[의견 영역] -->
        </div>
        <!-- /[rowbox] -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import ContentBlockCreatorInfo from "./ContentBlockCreatorInfo";

const HANWHA_DOMAINS = [
  "hanwha.com",
  "hanwha.co.kr",
  "hanwhalife.com",
  "hanwhain.com",
  "eagleoffice.co.kr",
  "172.[0-9]+.[0-9]+.[0-9]+"
];

export default {
  components: {
    UserTooltip,
    ContentBlockCreatorInfo,
  },
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
  },
  data() {
    return {
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      loading: true,
      messageList: [],
      files: [],
      fileUploadType: null,
      state: {
        linkMeta: [],
        subName: null,
        groupKbn: null,
        title: null,
      },
      userList: [],
      commentCount: this.blockInfo.commentCounts[this.bdata.paperBlockId],
      opinionEditorData: {
        deciName: null,
        paperId: String(this.paperInfo.paperId),
        contents: null,
        paperFileId: null,
        userId: null,
        fileName: null
      },
      members: this.boardMemberInfo.userList,
      opinionUpfile: {
        groupId: String(this.paperInfo.groupId),
        paperId: String(this.paperInfo.paperId),
        files: []
      },
      opiniondata: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null
      },
      files: [],
      udfform: {
        paperFileId: "",
        seq: "",
        fileId: "",
        fileName: ""
      },
      opiTargetName: this.$i18nUtil.trans("message.ContentBlockTypeDecision.004","결정자 선택"),
      self: this,

      blockModDate : '',
      blockRegDate: '',
      blockModUserName:'',
      blockRegUserName:'',
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
  },
  mounted() {
    let self = this;
    this.getContent();
    
    this.transmitter.subscribers[self.bdata.paperBlockId] = {
      subscribe: function (command, data, error) {
        self.stompEditorSubscribe(command, data, error);
      },
    };

    this.renderCompleted(function(){
      self.$emit("blockMatch");
    });
  },
  computed:{
    ...mapState("noti", ["notiBoardBlockId"]),
  },
  updated() {
    let list = this.$el.querySelectorAll("div.member img[data-user-id]");
    if (list) {
      for (let inx = 0; inx < list.length; inx++) {
        let elem = list[inx];
        let userId = elem.getAttribute("data-user-id");
        this.HW_GET_USER_PHOTO({img: elem, userId});
      }
    }
  },
  watch: {
    "state.groupKbn"() { },
    "state.subName"() { },
    "state.title"() { },
    "paperInfo.accessType"() { },
    "paperInfo.useExternalSite"() { },
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),
    stompEditorSubscribe(command, bdata, error) {
      if (command === "content") {
        if (
          bdata.paperId === this.paperInfo.paperId &&
          bdata.paperBlockId === this.bdata.paperBlockId
        ) {
          if(bdata.modDate != null){
            this.blockModDate = bdata.modDate;
            this.blockModUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.blockLockNameEn !== null ? bdata.blockLockNameEn : bdata.blockLockName;
          }
          if(bdata.regDate != null){
            this.blockRegDate = bdata.regDate;
            this.blockRegUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.regUserNameEn !== null ? bdata.regUserNameEn : bdata.regUserName;
          }
          return true;
        }
      }
      return false;
    },
    deleteFileBlock(e) {
      let self = this;
      /* 권한체크 RW = permission 2 */
      if (self.paperInfo.permission > 1) {
        self.deleteModal(self.$i18nUtil.trans("AG001"), (modal) => {
          modal.close();
          self.deleteBlock({ callback(res) {
            if (res && res.data && !res.data.errorCode) {
              self.boardUtil.removeBlockData(self.bdata.paperBlockId);
              let toastMsg = self.$i18nUtil.trans("TB078");
              self.toast(toastMsg);
            }
          }});
        });
      }
      else {
        /* 권한이 없습니다 */
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    getContent() {
      let self = this;
      let content = self.bdata.contentPath;
      {
        let element = document.createElement("div");
        element.innerHTML = self.bdata.contentPath;
        let tag = element.querySelector("a");
        if (tag) {
          if (self.state.linkMeta.length == 0) {
            setTimeout(() => {
              let data = {
                title: tag.getAttribute("data-meta-title"),
                image: tag.getAttribute("data-meta-image"),
                description: tag.getAttribute("data-meta-description"),
                linkType: tag.getAttribute("data-meta-linkType"),
                url: content,
              };
              self.state.linkMeta.splice(0, 1, data);
            }, 100);
          }
          content = tag.innerText;
          self.testBoardInfo(content);
        }
      }
      return content;
    },
    testBoardInfo(url) {
      let self = this;
      let match = self.boardUtil.matchBoardURL(url);
      if (match && match.length > 3 && !self.state.loading &&
        !self.state.subName && !self.state.groupKbn && !self.state.title) {
        self.state.loading = true;
        let paperId = match[3];
        let groupKbn = "PRO";
        let subName = "";
        let title = self.linkAttr("title");

        let request = {
          params: { paperId: paperId, },
          req: self.req,
          url: "/api/copaper/paper/getPaperInfo",
          method: "post",
        };
        self
          .COWORK_REST_SIMPLE_ACTION(request)
          .then((res) => {
            delete self.state.loading;
            if (self.boardUtil.hasSub(res, ["result"])) {
              let paperInfo = res.result;
              let categoryInfo = paperInfo.categoryInfo;

              groupKbn = paperInfo.groupInfo.groupKbn;
              subName = "";
              title = paperInfo.paperTitle;

              self.state.groupKbn = groupKbn;

              if (groupKbn == "PRO" || groupKbn == "USER") {
                subName = paperInfo.groupInfo.groupName;
                /* 전체공개 */
                if (paperInfo.docGrade == "NORMAL") { }
                /* 멤버만공개 */
                else if (paperInfo.docGrade == "RESTRICT") { }
                /* 비공개 */
                else if (paperInfo.docGrade == "SECRET") {
                  subName = "";
                  title = this.$i18nUtil.trans("message.ContentBlockTypeLink.001","비공개 보드입니다.");
                }
                // console.log("PAPER:", paperInfo);
              }
              /* 정보공유 */
              else if (groupKbn == "SHAR") {
                subName = categoryInfo.categoryName;
              }
              /* 회의협의 */
              else if (groupKbn == "CFRC") {
                subName = categoryInfo.categoryName;
              }

              self.state.subName = subName;
              self.state.title = title;
              // console.log("PAPER:", paperInfo);
            };
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    linkClicked() {
      let link = this.linkAttr("url");
      if (link) {
        let fromInner = this.paperInfo.accessType === "IN";
        let linkInner = this.testHanwha(link);
        let useExSite = this.paperInfo.useExternalSite;
        let openLink = false;


        /* 내부망 내부URL */
        if (fromInner && linkInner) {
          openLink = true;
        }
        /* 내부망 외부URL */
        else if (fromInner && !linkInner) {
          openLink = false;
        }
        /* 외부망 내부URL */
        else if (!fromInner && linkInner) {
          openLink = false;
        }
        /* 외부망 외부URL */
        else {
          openLink = true;
        }

        /* 내부망에서 외부사이트 접근 가능한 경우 오픈 */
        if (useExSite || openLink) {
          window.open(link);
        }
        /* 링크오픈 불가능 하고 내부망인 경우 */
        else if (fromInner) {
          this.alertModal(this.$i18nUtil.trans("AB059"));
        }
        /* 그밖의 사유로 오픈불가 */
        else {
          this.alertModal(this.$i18nUtil.trans("message.ContentBlockTypeImage.002","링크를 오픈할수 없습니다."));
        }
      }
    },
    opinionCreate() {
      /* 의사결정 위젯을 띄운다 */
      let el = this.$refs.opinionForm;
      el.classList.toggle("hidden");
      console.log("show opinion create form");
    },
    requestURLContent(url, element) {
      if (this.paperInfo.permission > 1) {
        this.$emit("requestURLContent", url, element);
      }
      else {
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    linkAttr(attr) {
      if (attr) {
        if (this.state.linkMeta[0]) {
          return this.state.linkMeta[0][attr];
        }
        return false;
      }
      else {
        return this.state.linkMeta[0];
      }
      return false;
    },
    /* 한화 URL 체크 */
    testHanwha(url) {
      let ptnPrefix = "^http[s]{0,1}:\/\/([a-zA-Z0-9]+[.]){0,}(";
      let ptnSuffix = ")([:][0-9]+){0,1}([/].*){0,1}$";
      for (let inx in HANWHA_DOMAINS) {
        let domain = HANWHA_DOMAINS[inx];
        domain = domain.replace(".", "\.");
        let ptn = new RegExp(ptnPrefix + domain + ptnSuffix);
        let mat = ptn.exec(url);
        if (mat) {
          return mat;
        }
      }
      return false;
    },
    copyURL() {
      this.boardUtil.copyClipboard(this.getContent())
      let toastMsg = this.$i18nUtil.trans("TB010");
      this.toast(toastMsg);
    },
  },
};
</script>
<style scoped>
.todo_wrap_view .view, 
.url_box .tit.content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 30px;
  display: block;
}

.url_box .tit.content.has_desc {
  margin-top: 10px;
}
.url_box .meta_description {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeLink.vue